import React, { Fragment } from "react";

const Resultado = (props) => {
    //declaro las propiedades que tendra Resultados, y vienen desde el APP.js
  const {nota, ponderacion } = props;

  const notaPresentacion=nota*ponderacion/100;
  const nota4 = 4;
  const restantePonderacion= 100-ponderacion;
  const notaPasar=(nota4-notaPresentacion)/restantePonderacion*100;


  return (
    <Fragment>
      <div className="u-full-width resultado">
        <h2>Nota del examen</h2>
        <p>Como nota de presentacion tienes un {notaPresentacion}</p>
        <p>La nota que debes sacar en tu examen es {notaPasar}</p>
      </div>
      
    </Fragment>
  );
};

export default Resultado;
